import getOpco from "./getOpco";

const getPaymentSelfcareToken = (): string => {
  const params = new URL(window.location.toString()).searchParams;
  const sharing_code = params.get("sharing_code");
  const source = params.get("source");
  const opco = getOpco();

  return sharing_code && source ? `sharing_code=${sharing_code}&source=${source}&opco=${opco}` : "";
};

export default getPaymentSelfcareToken;
